import React from "react"
import { Link } from "react-router-dom"
import CookieConsent from "react-cookie-consent"
import { FaYoutube, FaEnvelope } from "react-icons/fa"

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  })
}

function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="border-t border-gray-700">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
            {/* Courses Section */}
            <div className="flex flex-col">
              <h3 className="text-lg font-bold mb-4 text-white">Cursos Online</h3>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://www.udemy.com/course/curso-de-ingles-basico-adquira-uma-base-solida-no-idioma/?referralCode=DAD28CA36F4E068DB9E8"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-400 transition-colors text-sm"
                  >
                    Básico Completo
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.udemy.com/course/curso-de-ingles-intermediario-90-em-ingles-com-legendas/?referralCode=CAADBF2564957289B935"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-400 transition-colors text-sm"
                  >
                    Intermediário 1
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.udemy.com/course/curso-de-ingles-intermediario-2-lane-antunes/?referralCode=EB310BD715B67485024A"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-400 transition-colors text-sm"
                  >
                    Intermediário 2
                  </a>
                </li>
              </ul>
            </div>

            {/* Quick Links Section */}
            <div className="flex flex-col">
              <h3 className="text-lg font-bold mb-4 text-white">Links Rápidos</h3>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/"
                    onClick={scrollToTop}
                    className="text-gray-300 hover:text-blue-400 transition-colors text-sm"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/grammar"
                    onClick={scrollToTop}
                    className="text-gray-300 hover:text-blue-400 transition-colors text-sm"
                  >
                    Exercícios
                  </Link>
                </li>
                <li>
                  <Link
                    to="/login"
                    onClick={scrollToTop}
                    className="text-gray-300 hover:text-blue-400 transition-colors text-sm"
                  >
                    Criar Conta
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div className="flex flex-col">
              <h3 className="text-lg font-bold mb-4 text-white">Contato</h3>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCQEeN8e0GP1utzQi0luuJOw"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-gray-300 hover:text-red-500 transition-colors text-sm"
                  >
                    <FaYoutube size={16} />
                    YouTube
                  </a>
                </li>
                <li className="flex items-center gap-2 text-gray-300">
                  <FaEnvelope size={16} />
                  <a href="mailto:lanenglisht@gmail.com" className="hover:text-blue-400 transition-colors">
                    lanenglisht@gmail.com
                  </a>
                </li>
              </ul>
            </div>

            {/* About Section */}
            <div className="flex flex-col">
              <h3 className="text-lg font-bold mb-4 text-white">Sobre</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Aprenda inglês de forma prática e eficiente com cursos de qualidade. Desenvolvido para você alcançar seus objetivos no idioma.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-700 pt-8">
            <p className="text-center text-gray-400 text-sm">
              &copy; 2024 TeacherLaneAntunes.com.br - Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>

      {/* Cookie Consent */}
      <CookieConsent
        location="bottom"
        buttonText="Aceitar"
        cookieName="myCookieConsent"
        style={{ background: "#1a1a1a", borderTop: "1px solid #444" }}
        buttonStyle={{
          background: "#3970b4",
          color: "#f5f5f5",
          fontSize: "13px",
          borderRadius: "6px",
        }}
        expires={365}
      >
        Este site utiliza cookies para melhorar a experiência do usuário. Ao usar este site, você concorda com o uso de cookies.
      </CookieConsent>
    </footer>
  )
}

export default Footer
